import { Toast } from "vant";
import { isClient, isAndroid } from "@/utils/isTerminal.js";
import "@/assets/js/JSBridge.js";

export function initJSBridge(initJSBridgeRegisterEvent) {
  if (!isClient) {
    return;
  }

  if (window.JSBridge) {
    connectJSBridge(window.JSBridge, initJSBridgeRegisterEvent);
  } else {
    document.addEventListener(
      "JSBridgeReady",
      function() {
        connectJSBridge(window.JSBridge, initJSBridgeRegisterEvent);
      },
      false
    );
  }
}

function connectJSBridge(bridge, initJSBridgeRegisterEvent) {
  bridge.init(function(message, responseCallback) {
    console.log("JS got a message", message);
    let data = { "Javascript Responds": "Wee!" };
    console.log("JS responding with", data);
    bridge.callEventCallback(responseCallback, data, message);
  });
  initJSBridgeRegisterEvent(bridge);
  // bridge.registerEvent('testJavascriptHandler', function (message, responseCallback) {
  //     log('ObjC called testJavascriptHandler with', message)
  //     var responseData = {'Javascript Says': 'Right back atcha!'}
  //     log('JS responding with', responseData)
  //     bridge.callEventCallback(responseCallback, responseData, message);
  // })
  // window.sendMessage = function () {
  //     var data = 'Hello from JS button';
  //     log('JS sending message', data);
  //     bridge.send(null, data, function (responseData) {
  //         log('JS got response', responseData);
  //     });
  // },
  // window.sendEvent = function () {
  //     log('JS calling handler "Test.testNativeEvent"');
  //     bridge.send('Test.testNativeEvent', {'foo': 'bar'}, function (response) {
  //         log('JS got response', response);
  //     });
  // };
}

export function getShareInfoConfig(config) {
  let shareInfo =
    config.shareUrl +
    "," +
    config.shareTitle +
    "," +
    config.shareContent +
    "," +
    config.shareImgUrl;
  let returnVal = [];
  config.sharePlatform.forEach(r => {
    if (r === "NURSE_TOKEN") {
      returnVal.push({
        plat: r,
        share_data: shareInfo,
        jsbEvent: "copyPassword"
      });
    } else if (r === "NURSE_PHOTO") {
      returnVal.push({
        plat: r,
        share_data: shareInfo,
        jsbEvent: "opCallingCard"
      });
    } else {
      returnVal.push({ plat: r, share_data: shareInfo });
    }
  });
  return returnVal;
}

export function getHibirdConfig(config) {
  let returnVal = {
    UI_TITLE: {},
    UI_BTN: [],
    UI_PAGE: { page_type: window.PAGE_PATH }
  };
  if (config.hiddenNavBar) {
    returnVal["UI_PAGE"].page_hidden_nav_bar = 1;
  }

  if (config.hasTitle) {
    returnVal["UI_TITLE"] = {
      ui_elm: "title",
      visible: config.hasTitle,
      ui_elm_name: config.title
    };
  }
  if (config.hasReturnBtn) {
    returnVal["UI_BTN"].push({
      ui_elm: "return_btn",
      visible: config.hasReturnBtn,
      position: config.returnBtnPosition ? config.returnBtnPosition : 1,
      goback_add: config.returnBtnType
    });
  }
  if (config.hasCloseBtn && !config.hasReturnBtn) {
    returnVal["UI_BTN"].push({
      ui_elm: "close_btn",
      visible: config.hasCloseBtn,
      position: config.closeBtnPosition ? config.closeBtnPosition : 1
    });
  }
  if (config.hasCustomerServiceBtn) {
    returnVal["UI_BTN"].push({
      ui_elm: "service_btn",
      visible: config.hasCustomerServiceBtn
    });
  }
  if (config.hasShareBtn) {
    returnVal["UI_BTN"].push({
      ui_elm: "share_btn",
      visible: config.hasShareBtn,
      position: config.shareBtnPosition ? config.shareBtnPosition : 4,
      share_info: getShareInfoConfig(config.shareBtnInfo)
    });
  }
  if (config.hasCollectionBtn) {
    returnVal["UI_BTN"].push({
      ui_elm: "collection_btn",
      visible: config.hasCollectionBtn,
      ui_elm_name: config.collectionStatus ? "取消收藏" : "加入收藏",
      position: config.collectionBtnPosition ? config.collectionBtnPosition : 3,
      callback: "collectionHandler",
      collectionStatus: config.collectionStatus
    });
  }
  if (config.hasMessageBtn) {
    returnVal["UI_BTN"].push({
      ui_elm: "message_btn",
      visible: config.hasMessageBtn,
      position: config.messageBtnPosition ? config.messageBtnPosition : 4
    });
  }

  return returnVal;
}

export function gotoNative(url) {
  if (!isClient) return;
  let data = {
    page_url: url
  };
  JSBridge.callAPI("NFHybridAPIService.gotoNative", data, function() {});
}

export function gotoFaceLiveness(faceLivenessType = 1) {
  //1 只是实人认证；2实人认证+实名认证
  //回调函数注册为 faceLivenessResult    （status 0失败 1成功,type 1 只是实人认证；2实人认证+实名认证）
  JSBridge.callAPI(
    "NFHybridAPIService.goFaceLiveness",
    { faceLivenessType: faceLivenessType },
    function() {}
  );
}

export function shareNative(config = []) {
  if (!isClient) return;
  let data = {
    list: config
  };
  JSBridge.callAPI("NFHybridAPIService.goShare", data, function() {});
}
//直接分享接口，不调出面板
export function shareNativeApi(configStr) {
  // 此方法用于传入约定的字符串内容
  // 格式：在括号内，使用“,”进行分隔的内容数据，顺序为“分享地址、标题、内容、图片地址”（顺序不可混乱！）
  if (!isClient) return;
  isAndroid
    ? JSBridge.callAPI(
        "NLSocialShare.shareActionWithPromiseContent",
        configStr,
        function() {}
      )
    : JSBridge.callAPI(
        "NLSocialShare.shareActionWithPromiseContent",
        configStr,
        function() {}
      );
}

export function backNative(config = {}) {
  if (!isClient) return;
  JSBridge.callAPI("NFHybridAPIService.goback", config, function() {});
}

export function joinStudioNative(config = {}) {
  if (!isClient) return;
  JSBridge.callAPI("NFHybridAPIService.joinStudio", config, function() {});
}

export function goCopy(val) {
  if (!isClient) return;
  let data = {
    data: val
  };
  JSBridge.callAPI("NFHybridAPIService.goCopy", data, function() {});
}
// 客户按钮
export function gotoService() {
  if (!isClient) return;
  let data = {
    page_url: "nurse://callCenter"
  };
  JSBridge.callAPI("NFHybridAPIService.gotoNative", data, function() {});
}

export function goCall(tel) {
  if (!isClient) return;
  let data = {
    data: tel
  };
  JSBridge.callAPI("NFHybridAPIService.goCall", data, function() {});
}

export function goToast(option) {
  if (!isClient) return;
  JSBridge.callAPI("NFHybridAPIService.goToast", option, function() {});
}

export function showCertAlert(type, certInfo, alertType) {
  if (!isClient) return;
  let data = {
    certType: type,
    certInfo: certInfo,
    alertType: alertType
  };
  JSBridge.callAPI("NFHybridAPIService.showCertAlert", data, function() {});
}

// 刷新状态
export function goRefresh(val) {
  if (!isClient) return;
  let data = {
    type: val
  };
  JSBridge.callAPI("NFHybridAPIService.goRefresh", data, function() {});
}

/**
 * 数据埋点
 * @param page
 * @param event
 * @param properties
 */
export function dataBuryingPoint(page, event, properties = "") {
  // console.log(page, event, properties)
  if (!isClient) return;
  let data = {
    page: page,
    event: event,
    properties: JSON.stringify(properties)
  };
  JSBridge.callAPI("NFHybridAPIService.goAnalytics", data, function() {});
}

/**
 *
 客户端调起小程序需要参数
 title 标题
 content 内容
 imageUrl 图片
 username 配置小程序原始id
 path 小程序地址，需要拼接好参数
 webUrl  兼容低版本微信时使用的url地址
 */
export function goShareMiniProgram(params) {
  if (!isClient) return;
  JSBridge.callAPI(
    "NFHybridAPIService.goShareMiniProgram",
    params,
    function() {}
  );
}

/**
 * 异地登陆
 */
export function loginInvalid(params = {}) {
  if (!isClient) {
    localStorage.clear();
    return
  }
  JSBridge.callAPI("NFHybridAPIService.loginInvalid", params, function() {});
}

/**
 * 扫描身份证
 * @cardType 1 正面，2 反面
 *
 */
export function goScanCard(type) {
  if (!isClient) return;
  let data = {
    cardType: type
  };
  JSBridge.callAPI("NFHybridAPIService.goScanCard", data, function() {});
}

/**
 * JSB是否有该方法
 */
export function goCheckSupportStatus(event) {
  if (!isClient) return;
  let data = {
    event: event
  };
  JSBridge.callAPI(
    "NFHybridAPIService.goCheckSupportStatus",
    data,
    function() {}
  );
}

/**
 * 保存图片
 * {type: 1, data: base64}
 * {type: 2, data: url}
 */
export function goSaveImage(params = {}) {
  if (!isClient) return;
  JSBridge.callAPI("NFHybridAPIService.goSaveImage", params, function() {});
}

/**
 * 清空缓存
 */
export function clearCache(params = {}) {
  console.log('我在安卓执行清空web缓存啦')
  if (!isClient) return;
  JSBridge.callAPI("NFHybridAPIService.clearCache", params, function() {});
}

/**
 * 清空web缓存
 * >= 5.1.6
 *
 */
export function clearWebCache(params = {}) {
  console.log('我在ios执行清空web缓存啦')
  if (!isClient) return;
  JSBridge.callAPI("NFHybridAPIService.clearWebCache", params, function() {});
}

/**
 * 去评价
 */
export function goEvaluation(params = {}) {
  if (!isClient) return;
  JSBridge.callAPI("NFHybridAPIService.goEvaluation", params, function() {});
}

/**
 * 完善医院信息
 */
export function goCompletePersonalInfo() {
  if (!isClient) return;
  JSBridge.callAPI(
    "NFHybridAPIService.goCompletePersonalInfo",
    { type: 1 },
    function() {}
  );
}

export function sendData(data) {
  if (!isClient) return;
  JSBridge.send(null, data, function(responseData) {
    if (responseData.resultCode == "1") {
      console.log(responseData);
    } else {
      console.log(responseData);
    }
  });
}

/**
 * 系统是否允许通知
 */
export function checkNotificationEnable(params = {}) {
  if (!isClient) return;
  JSBridge.callAPI("NFHybridAPIService.checkNotificationEnable", params, function() {});
}

/**
 * 护士加APP是否允许通知
 */
export function checkAppNotificationEnable(params = {}) {
  if (!isClient) return;
  JSBridge.callAPI("NFHybridAPIService.checkAppNotificationEnable", params, function() {});
}


/* 
验证活动弹窗
 参数：
 url 地址
 params 请求参数
 返回：
 无 
 兼容：
 >=5.5.7
*/
export function checkActivityAlert(params = {}) {
  console.log('我执行弹窗方法了',params)
 if (!isClient) return;
 JSBridge.callAPI("NFHybridAPIService.checkActivityAlert", params, function() {});
}